import React, { useState, useRef } from "react";

function NewActivity({ categories = [], onCancel, onSubmit }) {
	const [active, setActive] = useState(null);
	const dateRef = useRef();

	if (active)
		return (
			<div className="card fade-in">
				<div className="card-body">
					<h2>
						{active.name}
						{"  "}
						<button
							onClick={() => setActive(null)}
							className="mdl-button mdl-js-button mdl-button--icon mdl-button--colored margin-left-10"
						>
							<i className="material-icons text-danger">close</i>
						</button>
					</h2>
					<form
						onSubmit={event => {
							event.preventDefault();
							onSubmit({
								category: active.id,
								datetime: dateRef.current.value
							});
						}}
					>
						<div className="form-group">
							<label htmlFor="datetime-id">Date & Time</label>
							<input
								type="datetime-local"
								className="form-control input-height"
								id="datetime-id"
								required
								ref={dateRef}
								name="datetime-id"
								aria-describedby="datetime-id"
							/>
						</div>
						<div className="form-group text-right fade-in">
							<button
								type="submit"
								className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success"
							>
								Submit
								<i className="material-icons">
									arrow_right_alt
								</i>
							</button>
							<button
								type="button"
								onClick={onCancel}
								className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-default"
							>
								Cancel
								<i className="material-icons text-danger">
									close
								</i>
							</button>
						</div>
					</form>
				</div>
			</div>
		);
	return (
		<div className="row m-t-20">
			{categories.map((item, idx) => (
				<div
					onClick={() => setActive(item)}
					key={idx}
					className="col-md-2 col-xs-6 col-sm-4 fade-in m-b-10"
					style={{ cursor: "pointer" }}
				>
					<div className="card cardbox h-100">
						<div className="card-body text-center">
							<center>
								<div
									style={{
										backgroundImage: `url(${item.image}`,
										width: "80px",
										height: "80px"
									}}
									className="img-container img-circle user-img-circle"
								></div>
							</center>
							<p>{item.name}</p>
						</div>
					</div>
				</div>
			))}
		</div>
	);
}

export default NewActivity;
